import { DocumentIcon } from '@heroicons/react/24/outline';

import { Icon } from '@/components/core/Icon';
import { MIME_TYPES } from '@/constants';

import { ReactComponent as HeroFileWord } from '../../../assets/icons/document-doc.svg';
import { ReactComponent as HeroFileJson } from '../../../assets/icons/document-json.svg';
import { ReactComponent as HeroFilePdf } from '../../../assets/icons/document-pdf.svg';
import { ReactComponent as HeroFilePpt} from '../../../assets/icons/document-ppt.svg';
import { ReactComponent as HeroFileText } from '../../../assets/icons/document-txt.svg';
import { ReactComponent as HeroFileExcel } from '../../../assets/icons/document-xls.svg';
import { ReactComponent as HeroFileArchive } from '../../../assets/icons/document-zip.svg';

interface NonDrawableURLPreviewProps {
    mimeType?: string;
    className?: string;
}

const NonDrawableURLPreview = ({ mimeType, className }: NonDrawableURLPreviewProps) => {
    const size = 'tw-h-8 tw-w-8';
    const variant = 'dark';

    switch(mimeType) {
        case MIME_TYPES.APPLICATION_PDF:
            return <HeroFilePdf className={`icon-variant-${variant} ${size} ${className}`} data-testid="file-pdf"/>;

        case MIME_TYPES.APPLICATION_MS_EXCEL:
        case MIME_TYPES.APPLICATION_VND_EXCEL:
        case MIME_TYPES.APPLICATION_VND_EXCEL_SHEET:
        case MIME_TYPES.TEXT_CSV:
            return <HeroFileExcel className={`icon-variant-${variant} ${size} ${className}`}/>;

        case MIME_TYPES.APPLICATION_MS_POWERPOINT:
        case MIME_TYPES.APPLICATION_VND_POWERPOINT:
            return <HeroFilePpt className={`icon-variant-${variant} ${size} ${className}`}/>;

        case MIME_TYPES.APPLICATION_VND_WORD:
        case MIME_TYPES.APPLICATION_MS_WORD:
            return <HeroFileWord className={`icon-variant-${variant} ${size} ${className}`}/>;

        case MIME_TYPES.APPLICATION_JSON:
            return <HeroFileJson className={`icon-variant-${variant} ${size} ${className}`}/>;

        case MIME_TYPES.APPLICATION_GZIP:
        case MIME_TYPES.APPLICATION_ZIP:
        case MIME_TYPES.APPLICATION_VND_RAR:
            return <HeroFileArchive className={`icon-variant-${variant} ${size} ${className}`}/>;

        case MIME_TYPES.TEXT_PLAIN:
            return <HeroFileText className={`icon-variant-${variant} ${size} ${className}`}/>;

        default:
            return <Icon icon={DocumentIcon} size='2xl' variant={variant} className={className} />;
    }
};

export { NonDrawableURLPreview };
